// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/style." + {"97":"8fcfa9511c21cf475b14","395":"dd7f0f9fd800d60ad020","421":"6bea6c9db0c2530dcfb2","465":"135cf90fef864ca721b0","869":"ba44d30e7d9d1840d7d1"}[chunkId] + ".css";
};